import { createGlobalStyle, css } from 'styled-components';

const durations = '0.3s';

const panelMotion = css`
  &-enter,
  &-appear,
  &-leave {
    &-start {
      transition: none !important;
    }

    &-active {
      transition: all ${durations};
    }
  }
`;

export const DrawerStyles = createGlobalStyle`
  .rc-drawer {
    &.rc-drawer-right,
    &.rc-drawer-left,
    &.rc-drawer-top {
      top: 60px;
    }

    .ui-drawer .rc-drawer-content-wrapper {
      box-shadow: ${({ theme }) => theme.shadows.medium};
    }

    .rc-drawer-content {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;

      .ui-drawer-body {
        flex: 1;
        min-width: 0;
        min-height: 0;
        padding: 24px;
        overflow: auto;
      }

      .life-id-drawer-body {
        padding: 0;
      }
    }

    .rc-drawer-mask {
      background: ${({ theme }) => theme.color.surface.backdrop};

      .close-mask& {
        cursor: pointer;
      }
    }
  }

  .mask-motion {
    &-enter,
    &-appear,
    &-leave {
      &-active {
        transition: all ${durations};
      }
    }

    &-enter,
    &-appear {
      opacity: 0;

      &-active {
        opacity: 1;
      }
    }

    &-leave {
      opacity: 1;

      &-active {
        opacity: 0;
      }
    }
  }

  .panel-motion {
    &-left {
      ${panelMotion};

      &-enter,
      &-appear {
        transform: translateX(-100%);

        &-active {
          transform: translateX(0);
        }
      }

      &-leave {
        transform: translateX(0);

        &-active {
          transform: translateX(-100%) !important;
        }
      }
    }

    &-right {
      ${panelMotion};

      &-enter,
      &-appear {
        transform: translateX(100%);

        &-active {
          transform: translateX(0);
        }
      }

      &-leave {
        transform: translateX(0);

        &-active {
          transform: translateX(100%) !important;
        }
      }
    }
  }
`;
